/**
 * Vespera legt selbst auf, wenn das Gespräch vorbei ist. (23.09.2026, Ticket 2521)
 *
 * Martin wünscht sich, „dass das System automatisch ein Signal zum Auflegen
 * oder Beenden der Verbindung an das Telefon sendet, sobald das Gespräch
 * beendet wird". Bisher blieb der Anruf offen, bis er selbst auflegte.
 *
 * Der Weg: Das Modell ruft am Ende das Werkzeug `anruf_beenden` (agent/
 * anruf-beenden.ts). Die App sieht dessen Karte und legt auf — aber erst,
 * wenn die Verabschiedung zu Ende gesprochen ist, sonst schnitte sie Vespera
 * mitten im „Bis bald" ab.
 *
 * ⚠️ Der Name steht HIER, weil ihn zwei Seiten brauchen (Agent und App).
 */
export const ANRUF_BEENDEN = "anruf_beenden";

/**
 * So lange muss Vespera still sein, bevor aufgelegt wird.
 *
 * ⚠️ Nicht kürzer: ruft das Modell das Werkzeug VOR dem gesprochenen
 *    Abschied, vergeht bis zum ersten Ton der Verabschiedung rund eine
 *    Sekunde. Mit 1,2 s wäre sie abgeschnitten worden.
 */
export const RUHE_VOR_AUFLEGEN_MS = 2000;
/** Spätestens dann wird aufgelegt, auch wenn noch etwas klingt. */
export const LAENGSTENS_BIS_AUFLEGEN_MS = 12_000;

/**
 * Jetzt auflegen?
 *
 * @param stillSeitMs  wie lange Vespera schon nicht mehr spricht (0 = spricht gerade)
 * @param wartetSeitMs wie lange seit dem Signal gewartet wird
 * @param nutzerSprach hat Martin nach dem Signal noch etwas gesagt?
 */
export function jetztAuflegen(
  stillSeitMs: number,
  wartetSeitMs: number,
  nutzerSprach: boolean,
): "auflegen" | "warten" | "abbrechen" {
  // Wer nach der Verabschiedung noch etwas sagt („warte, eine Frage noch"),
  // hat das Gespräch nicht beendet.
  if (nutzerSprach) return "abbrechen";
  if (stillSeitMs >= RUHE_VOR_AUFLEGEN_MS) return "auflegen";
  if (wartetSeitMs >= LAENGSTENS_BIS_AUFLEGEN_MS) return "auflegen";
  return "warten";
}
